import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, Search, Phone, ArrowRight } from 'lucide-react';

const NotFound = ({ onQuoteClick }) => {
  const services = [
    { name: 'Canopy, Duct & Fan Cleaning', path: '/services/canopy-duct-fan-cleaning-perth' },
    { name: 'Commercial Kitchen Cleaning', path: '/services/commercial-kitchen-cleaning-perth' },
    { name: 'Warehouse & Industrial Cleaning', path: '/services/warehouse-industrial-cleaning-perth' },
    { name: 'Commercial Office Cleaning', path: '/services/commercial-office-cleaning-perth' },
    { name: 'Commercial Window Cleaning', path: '/services/commercial-window-cleaning-perth' },
    { name: 'Commercial Carpet Cleaning', path: '/services/commercial-carpet-cleaning-perth' },
    { name: 'High-Pressure Cleaning', path: '/services/commercial-high-pressure-cleaning-perth' },
    { name: 'Pizza Oven Cleaning', path: '/services/commercial-pizza-oven-cleaning-perth' },
  ];

  return (
    <>
      <Helmet>
        <title>Page Not Found | Extreme Clean Australia</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-[70vh] flex items-center justify-center bg-gray-50 pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* 404 Header */}
          <div className="mb-8">
            <h1 className="text-8xl sm:text-9xl font-bold text-[#3B82F6] mb-4">404</h1>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h2>
            <p className="text-lg text-gray-600 max-w-lg mx-auto">
              Sorry, the page you're looking for doesn't exist or has been moved. 
              Let us help you find what you need.
            </p>
          </div>

          {/* Quick Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-[#3B82F6] text-white px-6 py-3 font-semibold hover:bg-[#273268] transition-colors rounded"
              data-testid="404-home-link"
            >
              <Home size={20} />
              Back to Homepage
            </Link>
            <button
              onClick={onQuoteClick}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#3B82F6] text-[#3B82F6] px-6 py-3 font-semibold hover:bg-[#3B82F6] hover:text-white transition-colors rounded"
              data-testid="404-quote-btn"
            >
              <Phone size={20} />
              Get a Free Quote
            </button>
          </div>

          {/* Services Links */}
          <div className="bg-white rounded-lg shadow-lg p-8 text-left">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
              <Search size={24} className="text-[#3B82F6]" />
              Our Services
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {services.map((service) => (
                <Link
                  key={service.path}
                  to={service.path}
                  className="flex items-center gap-2 text-gray-700 hover:text-[#3B82F6] transition-colors p-2 rounded hover:bg-gray-50"
                  data-testid={`404-service-${service.path.split('/').pop()}`}
                >
                  <ArrowRight size={16} className="text-[#3B82F6] flex-shrink-0" />
                  <span>{service.name}</span>
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="mt-8 text-gray-600">
            <p>
              Need help? Call us at{' '}
              <a 
                href="tel:0861875523" 
                className="text-[#3B82F6] font-semibold hover:underline"
              >
                08 6187 5523
              </a>
              {' '}or{' '}
              <Link 
                to="/contact" 
                className="text-[#3B82F6] font-semibold hover:underline"
              >
                contact us online
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
